const baseUrl = process.env.BASE_URL || 'https://secretpass.polussolutions.com'
export const Corporate_url=process.env.corporateUrl || 'https://corporateportal.polussolutions.com'
export default baseUrl;      
